import React from 'react';
import { PaymentMethod, CreditCard, PaymentMethodType, PaymentOnTerms } from '@css-xp/graphtypes';
import { PaymentMethodElement, PaymentMethodId } from '@atlassian/commerce-payment-methods';
import { PaymentErrorLozenge } from '../../../copyable-text';

export const PaymentMethodDetails = ({ paymentMethod }: { paymentMethod?: PaymentMethod | null }) => {
  if (!paymentMethod) {
    return (
      <span>
        <em>No payment method</em>
      </span>
    );
  }

  switch (paymentMethod?.type) {
    case PaymentMethodType.CARD: {
      const creditCard = paymentMethod as CreditCard;
      // convert expMonth & expYear to Numbers
      const expMonth = +(creditCard.card?.expirationMonth ?? 0);
      const expYear = +(creditCard.card?.expirationYear ?? 0);

      return (
        <span>
          <PaymentMethodElement
            paymentMethod={{
              id: (paymentMethod.id as PaymentMethodId) ?? '',
              type: paymentMethod.type,
              card: {
                brand: creditCard.card?.brand ?? '',
                expMonth,
                expYear,
                last4: creditCard.card?.last4Numbers ?? '',
              },
              default: paymentMethod.default ?? false,
            }}
          />
          {paymentMethod.paymentIssue && <PaymentErrorLozenge />}
        </span>
      );
    }
    case PaymentMethodType.DEFERRED: {
      const paymentOnTerms = paymentMethod as PaymentOnTerms;
      return <span>Payment on terms: due in {paymentOnTerms.terms?.invoiceDueDays} days</span>;
    }
    default:
      return (
        <span>
          <em>Unknown payment method</em>
        </span>
      );
  }
};
